/** ビューポート座標系の矩形。DOMRectを直接受け取らず、テスト容易性のため最小限の数値だけを要求する。 */
export interface AnchorRect {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

export interface Size {
  width: number;
  height: number;
}

export interface PopoverPosition {
  left: number;
  top: number;
}

export interface PopoverPositionOptions {
  /** アンカー要素とポップオーバーの間隔(px)。既定4px。 */
  anchorGap?: number;
  /** ビューポート端からの最小マージン(px)。既定8px。 */
  edgeGap?: number;
}

const DEFAULT_ANCHOR_GAP = 4;
const DEFAULT_EDGE_GAP = 8;

/**
 * アンカー要素の矩形とポップオーバー・ビューポートのサイズから、
 * 画面内に収まる表示位置を計算する(flip/clampパターン)。
 */
export function computePopoverPosition(
  anchorRect: AnchorRect,
  popoverSize: Size,
  viewport: Size,
  options?: PopoverPositionOptions,
): PopoverPosition {
  const anchorGap = options?.anchorGap ?? DEFAULT_ANCHOR_GAP;
  const edgeGap = options?.edgeGap ?? DEFAULT_EDGE_GAP;

  const spaceBelow = viewport.height - anchorRect.bottom;
  const spaceAbove = anchorRect.top;
  const requiredSpace = popoverSize.height + anchorGap + edgeGap;
  const fitsBelow = spaceBelow >= requiredSpace;
  const fitsAbove = spaceAbove >= requiredSpace;

  const top =
    fitsBelow || !fitsAbove
      ? anchorRect.bottom + anchorGap
      : anchorRect.top - anchorGap - popoverSize.height;

  return {
    left: clamp(anchorRect.left, edgeGap, viewport.width, popoverSize.width),
    top: clamp(top, edgeGap, viewport.height, popoverSize.height),
  };
}

function clamp(
  value: number,
  edgeGap: number,
  viewportExtent: number,
  size: number,
): number {
  const max = Math.max(edgeGap, viewportExtent - size - edgeGap);
  return Math.min(Math.max(value, edgeGap), max);
}
